import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import DistillPage from "../pages/DistillPage";
import DistillPageV2 from "../pages/DistillPageV2";
import ExplorePage from "../pages/ExplorePage";
import SharePage from "../pages/SharePage";
import LoginSuccess from "../pages/LoginSuccess";
import AdminTemplates from "../pages/AdminTemplates";
import CampaignPlannerPage from "../pages/CampaignPlannerPage";
import UserDashboard from "../pages/UserDashboard";
import VoiceProfilePage from "../pages/VoiceProfilePage";
import ErrorBoundary from "../components/ErrorBoundary";

// Page-level fallback: shown when an entire page crashes.
// Offers a reload and a way back to the home page.
function PageFallback({ page }: { page: string }) {
  return (
    <div style={{
      display:        'flex',
      flexDirection:  'column',
      alignItems:     'center',
      justifyContent: 'center',
      minHeight:      '80vh',
      fontFamily:     "'DM Sans', sans-serif",
      color:          '#888',
      textAlign:      'center',
      padding:        '40px',
      background:     '#0d0d0d',
    }}>
      <div style={{ fontSize: '24px', marginBottom: '12px', color: '#ca5f5f' }}>⚠</div>
      <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '6px', color: '#ccc' }}>
        {page} couldn't load
      </div>
      <div style={{ fontSize: '13px', marginBottom: '20px', maxWidth: '340px' }}>
        An unexpected error occurred on this page. You can reload or go back home.
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          style={{
            padding: '8px 18px', borderRadius: '8px', border: 'none',
            background: '#A89FFF', color: '#0d0d0d', cursor: 'pointer',
            fontSize: '13px', fontWeight: 600,
          }}
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
        <button
          style={{
            padding: '8px 18px', borderRadius: '8px',
            border: '1px solid #444', background: 'transparent',
            color: '#ccc', cursor: 'pointer', fontSize: '13px',
          }}
          onClick={() => { window.location.href = '/'; }}
        >
          Go home
        </button>
      </div>
    </div>
  );
}

const Routes: React.FC = () => (
    <Switch>
        <Route exact path="/">
            <ErrorBoundary fallback={<PageFallback page="Home" />}>
                <LandingPage />
            </ErrorBoundary>
        </Route>
        {/* /app serves the V1 page — kept accessible for power users / admin */}
        <Route exact path="/app">
            <ErrorBoundary fallback={<PageFallback page="App" />}>
                <DistillPage />
            </ErrorBoundary>
        </Route>
        <Route exact path="/explore">
            <ErrorBoundary fallback={<PageFallback page="Explore" />}>
                <ExplorePage />
            </ErrorBoundary>
        </Route>
        <Route exact path="/share/:token">
            <ErrorBoundary fallback={<PageFallback page="Share" />}>
                <SharePage />
            </ErrorBoundary>
        </Route>
        <Route exact path="/login-success" component={LoginSuccess} />
        <Route exact path="/admin/templates">
            <ErrorBoundary fallback={<PageFallback page="Admin" />}>
                <AdminTemplates />
            </ErrorBoundary>
        </Route>
        <Route exact path="/distill-v2">
            <ErrorBoundary fallback={<PageFallback page="Distill V2" />}>
                <DistillPageV2 />
            </ErrorBoundary>
        </Route>
        <Route exact path="/campaign-planner">
            <ErrorBoundary fallback={<PageFallback page="Campaign Planner" />}>
                <CampaignPlannerPage />
            </ErrorBoundary>
        </Route>
        <Route exact path="/dashboard">
            <ErrorBoundary fallback={<PageFallback page="Dashboard" />}>
                <UserDashboard />
            </ErrorBoundary>
        </Route>
        {/* Rollback: remove this route + the nav link in UserDashboard DashNav */}
        <Route exact path="/voice-profile">
            <ErrorBoundary fallback={<PageFallback page="Voice Profile" />}>
                <VoiceProfilePage />
            </ErrorBoundary>
        </Route>
    </Switch>
);

export default Routes;
